import {Axios} from "axios";
import { Store } from "vuex";
import {Router} from "vue-router";

export function debounce<T extends (...args: any[]) => void>(fn: T, delay: number): T {
  let timeoutID: number | null | any = null;

  return function (this: any, ...args: any[]) {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }

    timeoutID = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  } as T;
}

export const setupAxiosDefaults = (store: Store<any>, axios: Axios) =>  {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters.getAuth.token
}

export const setupAxios = (store: Store<any>, axios: Axios, router: Router) => {
  let auth = {
    isRefreshing: false,
    refreshingCall: undefined as undefined|Promise<any>,
  }

  function refreshToken(cb: any) {
    if (auth.isRefreshing) {
      return auth.refreshingCall?.then(cb);
    }

    auth.isRefreshing = true;

    const refreshToken = store.getters.getAuth.refreshToken;
    auth.refreshingCall = axios.post('/token/refresh', {refreshToken: refreshToken}, {headers: {Authorization: ""}})
        .then(tokenRefreshResponse => {
          store.commit('authenticate', tokenRefreshResponse.data);
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + tokenRefreshResponse.data.token
          auth.isRefreshing = false;
          auth.refreshingCall = undefined;

          return Promise.resolve(tokenRefreshResponse.data.token);
        }).then(cb);
    return auth.refreshingCall;
  }

  axios.interceptors.response.use(
      (response) => response,
      async (error) => {
        const request = error.config;
        if (
            request &&
            request.url === '/token/refresh' &&
            request.method === 'post' &&
            error &&
            error.response &&
            error.response.status === 401
        ) {
          store.commit('removeAuth');
          router.push('login')
          window.location.reload();
          return;
        }

        if (error && error.response && error.response.status === 401) {
          return refreshToken(() => {
            error.config.headers['Authorization'] = 'Bearer ' + store.getters.getAuth?.token
            return axios.request(error.config);
          });
        }

        throw error;
      }
  );
}
